import './App.css';
import {  BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthRoutes from './routes/AuthRoutes';
import DashboardRoutes from './routes/DashboardRoutes';
import { addLocale, locale } from 'primereact/api';

function App() {
  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    today: 'Hoy',

    startsWith: 'Empieza con',
    contains: 'Contiene',
    notContains: 'No contiene',
    endsWith: 'Termina con',
    equals: 'Igual a',
    notEquals: 'Distinto de',
    noFilter: 'Sin filtro',
    lt: 'Menor que',
    lte: 'Menor o igual que',
    gt: 'Mayor que',
    gte: 'Mayor o igual que',

    dateIs: 'Fecha es',
    dateIsNot: 'Fecha no es',
    dateBefore: 'Fecha anterior a',
    dateAfter: 'Fecha posterior a',

    clear: 'Limpiar',
    apply: 'Aplicar',
    matchAll: 'Cumplir todas',
    matchAny: 'Cumplir alguna',
    addRule: 'Añadir regla',
    removeRule: 'Quitar regla',

    accept: 'Sí',
    reject: 'No',
    choose: 'Elegir',
    upload: 'Subir',
    cancel: 'Cancelar',

  });

  locale('es');

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/auth/login" replace />} />

        {/* Login */}
        <Route path="/auth/*" element={<AuthRoutes/>} />

        {/* Post-Login */}
        <Route path="/app/*" element={<DashboardRoutes />} />

      </Routes>
    </Router>
  );
}

export default App;
